/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React ,{ useState } from 'react';
import { Button } from '@mui/material';
import OrgCreation from './OrgCreation';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';

const OrgCreationBtn = () => {
    const [openOrgCreationModal,setOpenOrgCreationModal] = useState(false); 
    const handleCloseDialog = ()=>{
        setOpenOrgCreationModal(false)
    }
    return (
        <>
            <Button variant="contained" sx={{background: (theme) =>theme.palette.gradiant.main}}  onClick={() =>setOpenOrgCreationModal(true)} style={{float:'right'}}>Register Organization</Button>
            <DialogContainer
                open={openOrgCreationModal}
                handleClose={handleCloseDialog}
            >
                <OrgCreation handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

export default OrgCreationBtn;
